import Transportation38Header from "./Header";
import "./index.css";
import Transportation38Table from "./Transportation";
import { ShowHide } from "../components/ShowHideProduct";
import { usePDFShowHide } from "../../../../hooks/usePDFShowHide";

const Transportation38Components = ({ productId }) => {
  const [show, setShow] = usePDFShowHide(false, {
    forceShowInPDF: true,
    pdfDelay: 1000,
  });

  return (
    <div className="transportation-38-container" id="transportation-38-id">
      <Transportation38Header productId={productId} show={show} />
      <ShowHide show={show} setShow={setShow} />
      {show && (
        <div className="prod-component-contents">
          <Transportation38Table productId={productId} />
        </div>
      )}
    </div>
  );
};

export default Transportation38Components;

